import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createBlock as _createBlock, Fragment as _Fragment, renderList as _renderList, resolveDirective as _resolveDirective } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-body p-10 p-lg-15" }
const _hoisted_3 = {
  key: 0,
  class: "buttons-wrap"
}
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Одобрить ")
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Отклонить ")
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Удалить ")
const _hoisted_7 = { class: "form-check form-check-custom form-check-solid d-flex justify-content-center align-items-start" }
const _hoisted_8 = { class: "form-check form-check-custom form-check-solid d-flex justify-content-center" }
const _hoisted_9 = ["onUpdate:modelValue"]
const _hoisted_10 = { class: "form-check form-check-custom form-check-solid d-flex justify-content-center align-items-start" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", null, " ID ", -1)
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = { class: "d-flex align-items-center gap-2" }
const _hoisted_14 = ["title"]
const _hoisted_15 = { class: "mb-0 pl-2" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("p", { class: "p-2 mb-0 text-center cursor-pointer" }, [
  /*#__PURE__*/_createElementVNode("span", null, " Название ")
], -1)
const _hoisted_17 = { class: "h5 mt-4 word-break_normal" }
const _hoisted_18 = {
  key: 0,
  class: "text-danger mb-0",
  style: {"font-weight":"bold"}
}
const _hoisted_19 = { class: "bordered w-100" }
const _hoisted_20 = { key: 0 }
const _hoisted_21 = { colspan: "2" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-envelope fs-5" }, null, -1)
const _hoisted_23 = { style: {"padding-left":"6px"} }
const _hoisted_24 = { key: 1 }
const _hoisted_25 = { colspan: "2" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-telephone-fill fs-5" }, null, -1)
const _hoisted_27 = { style: {"padding-left":"6px"} }
const _hoisted_28 = { key: 2 }
const _hoisted_29 = { colspan: "2" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-link-45deg fs-5" }, null, -1)
const _hoisted_31 = { style: {"padding-left":"6px"} }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("td", { class: "w-50" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "paragraph my-1 mx-3" }, " Создан ")
], -1)
const _hoisted_33 = { class: "w-50" }
const _hoisted_34 = { class: "paragraph my-1 mx-3" }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("p", { class: "paragraph my-1 mx-3" }, " Изменен ")
], -1)
const _hoisted_36 = { class: "paragraph my-1 mx-3" }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("p", { class: "p-2 mb-0 text-center" }, " Модерация ", -1)
const _hoisted_38 = { class: "mb-2 w-180px" }
const _hoisted_39 = { key: 0 }
const _hoisted_40 = { key: 0 }
const _hoisted_41 = /*#__PURE__*/_createElementVNode("p", null, " Причины: ", -1)
const _hoisted_42 = {
  href: "#",
  target: "_blank",
  class: "mb-0"
}
const _hoisted_43 = { key: 1 }
const _hoisted_44 = /*#__PURE__*/_createElementVNode("p", null, " Не одобрялся ", -1)
const _hoisted_45 = [
  _hoisted_44
]
const _hoisted_46 = { key: 0 }
const _hoisted_47 = { key: 0 }
const _hoisted_48 = /*#__PURE__*/_createElementVNode("p", null, " Причины: ", -1)
const _hoisted_49 = { class: "mb-2" }
const _hoisted_50 = {
  href: "#",
  target: "_blank",
  class: "mb-0"
}
const _hoisted_51 = { key: 1 }
const _hoisted_52 = /*#__PURE__*/_createElementVNode("p", null, " Не отклонялся ", -1)
const _hoisted_53 = [
  _hoisted_52
]
const _hoisted_54 = ["onClick"]
const _hoisted_55 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-check-circle-fill fs-3 text-primary" }, null, -1)
const _hoisted_56 = [
  _hoisted_55
]
const _hoisted_57 = {
  class: "btn btn-sm btn-icon btn-active-icon-primary overflow-hidden",
  title: "Редактировать компанию"
}
const _hoisted_58 = /*#__PURE__*/_createElementVNode("i", { class: "bi-pencil-square fs-3 text-success" }, null, -1)
const _hoisted_59 = ["disabled", "onClick"]
const _hoisted_60 = {
  key: 1,
  class: "buttons-wrap"
}
const _hoisted_61 = /*#__PURE__*/_createTextVNode(" Одобрить ")
const _hoisted_62 = /*#__PURE__*/_createTextVNode(" Отклонить ")
const _hoisted_63 = /*#__PURE__*/_createTextVNode(" Удалить ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_vue_easy_lightbox = _resolveComponent("vue-easy-lightbox")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_checkbox_group = _resolveComponent("el-checkbox-group")!
  const _component_el_timeline_item = _resolveComponent("el-timeline-item")!
  const _component_el_timeline = _resolveComponent("el-timeline")!
  const _component_el_collapse_item = _resolveComponent("el-collapse-item")!
  const _component_el_collapse = _resolveComponent("el-collapse")!
  const _component_el_button_group = _resolveComponent("el-button-group")!
  const _component_el_empty = _resolveComponent("el-empty")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_companies_filter = _resolveComponent("companies-filter")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_companies_filter, {
        onFilterCompaniesButtonClick: _ctx.filterCompaniesButtonClick,
        "items-total": _ctx.totalItems,
        "pages-total": _ctx.totalPages,
        "current-page": _ctx.companiesFilterData.page
      }, {
        default: _withCtx(() => [
          (_ctx.tableHasContent)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createVNode(_component_el_button, {
                  size: "small",
                  type: "success",
                  title: 
              !_ctx.someCheckboxesAreChecked
                ? 'Выберите хотя бы один элемент из списка'
                : 'Одобрить компании'
            ,
                  disabled: !_ctx.someCheckboxesAreChecked,
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.allowEntriesBulk()))
                }, {
                  default: _withCtx(() => [
                    _hoisted_4
                  ]),
                  _: 1
                }, 8, ["title", "disabled"]),
                _createVNode(_component_el_button, {
                  size: "small",
                  type: "warning",
                  title: _ctx.rejectButtonTitle,
                  disabled: _ctx.bulkRejectStatus,
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.rejectEntriesBulk()))
                }, {
                  default: _withCtx(() => [
                    _hoisted_5
                  ]),
                  _: 1
                }, 8, ["title", "disabled"]),
                _createVNode(_component_el_button, {
                  size: "small",
                  type: "danger",
                  title: 
              !_ctx.someCheckboxesAreChecked
                ? 'Выберите хотя бы один элемент из списка'
                : 'Удалить компании'
            ,
                  disabled: !_ctx.someCheckboxesAreChecked,
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.deleteEntriesBulk()))
                }, {
                  default: _withCtx(() => [
                    _hoisted_6
                  ]),
                  _: 1
                }, 8, ["title", "disabled"])
              ]))
            : _createCommentVNode("", true),
          _createVNode(_component_vue_easy_lightbox, {
            scrollDisabled: false,
            visible: _ctx.lightboxVisible,
            imgs: _ctx.lightboxImage,
            onHide: _ctx.closeLightbox
          }, null, 8, ["visible", "imgs", "onHide"]),
          _withDirectives((_openBlock(), _createBlock(_component_el_table, {
            border: "",
            data: _ctx.itemsList,
            "scrollbar-always-on": true,
            style: {"width":"100%"},
            "table-layout": "auto",
            "show-header": true,
            resizable: true
          }, {
            empty: _withCtx(() => [
              _createVNode(_component_el_empty, {
                "image-size": 300,
                description: "Ничего не найдено"
              })
            ]),
            default: _withCtx(() => [
              _createVNode(_component_el_table_column, {
                align: "top",
                class: "py-5 px-0 fw-bolder text-center min-w-50px align-top",
                width: "50",
                property: "checked"
              }, {
                header: _withCtx(() => [
                  _createElementVNode("div", _hoisted_7, [
                    (_ctx.itemsList.length > 1)
                      ? _withDirectives((_openBlock(), _createElementBlock("input", {
                          key: 0,
                          type: "checkbox",
                          id: "flexCheckDefault",
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.checkedModel) = $event)),
                          class: "form-check-input",
                          onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.switchAllCheckboxes && _ctx.switchAllCheckboxes(...args)))
                        }, null, 512)), [
                          [_vModelCheckbox, _ctx.checkedModel]
                        ])
                      : _createCommentVNode("", true)
                  ])
                ]),
                default: _withCtx((scope) => [
                  _createElementVNode("div", _hoisted_8, [
                    _withDirectives(_createElementVNode("input", {
                      type: "checkbox",
                      "onUpdate:modelValue": ($event: any) => ((scope.row.checked) = $event),
                      class: "form-check-input"
                    }, null, 8, _hoisted_9), [
                      [_vModelCheckbox, scope.row.checked]
                    ])
                  ])
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                property: "id",
                label: "ID",
                width: "110"
              }, {
                header: _withCtx(() => [
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("p", {
                      class: "p-2 mb-0 cursor-pointer",
                      onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.sortTheColumn('id')))
                    }, _hoisted_12)
                  ])
                ]),
                default: _withCtx((scope) => [
                  _createElementVNode("div", {
                    class: _normalizeClass(_ctx.rowClasses)
                  }, [
                    _createElementVNode("div", _hoisted_13, [
                      _createElementVNode("i", {
                        class: _normalizeClass(["bi fs-1x mr-2", {
                      'bi-patch-check-fill text-primary':
                        scope.row.status === 'confirmed',
                      'bi-patch-minus-fill text-danger':
                        scope.row.status === 'rejected',
                      'bi-patch-exclamation-fill text-warning':
                        scope.row.status === 'not_verified',
                    }]),
                        title: _ctx.makeStatusTitle(scope.row.status)
                      }, null, 10, _hoisted_14),
                      _createElementVNode("p", _hoisted_15, [
                        _createVNode(_component_router_link, {
                          class: "underline text-success",
                          to: {
                        name: 'companies-edit',
                        params: {
                          id: scope.row.id,
                          entry: JSON.stringify(scope.row),
                        },
                      }
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(scope.row.id), 1)
                          ]),
                          _: 2
                        }, 1032, ["to"])
                      ])
                    ])
                  ], 2)
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, { width: "300" }, {
                header: _withCtx(() => [
                  _hoisted_16
                ]),
                default: _withCtx((scope) => [
                  _createElementVNode("div", {
                    class: _normalizeClass(_ctx.rowClasses)
                  }, [
                    (scope.row.photo && !_ctx.isEmptyObject(scope.row.photo))
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          (scope.row.photo)
                            ? (_openBlock(), _createBlock(_component_el_image, {
                                key: 0,
                                style: {"width":"250px","height":"auto","cursor":"pointer"},
                                src: scope.row.photo.path,
                                onClick: ($event: any) => (_ctx.openLightbox(scope.row.photo.path))
                              }, null, 8, ["src", "onClick"]))
                            : _createCommentVNode("", true)
                        ], 64))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", {
                      class: _normalizeClass(["my-2 flex", _ctx.rowClasses])
                    }, [
                      _createElementVNode("h4", _hoisted_17, _toDisplayString(scope.row.name), 1),
                      (!scope.row.has_user)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_18, " Нет пользователя "))
                        : _createCommentVNode("", true)
                    ], 2),
                    _createElementVNode("table", _hoisted_19, [
                      (scope.row.emails.length > 0)
                        ? (_openBlock(), _createElementBlock("tr", _hoisted_20, [
                            _createElementVNode("td", _hoisted_21, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(scope.row.emails, (email, emailIndex) => {
                                return (_openBlock(), _createElementBlock("p", {
                                  class: "paragraph my-1 mx-3 d-flex align-items-center",
                                  key: emailIndex
                                }, [
                                  _hoisted_22,
                                  _createElementVNode("span", _hoisted_23, _toDisplayString(email), 1)
                                ]))
                              }), 128))
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (scope.row.phones.length > 0)
                        ? (_openBlock(), _createElementBlock("tr", _hoisted_24, [
                            _createElementVNode("td", _hoisted_25, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(scope.row.phones, (phone, phoneIndex) => {
                                return (_openBlock(), _createElementBlock("p", {
                                  class: "paragraph my-1 mx-3 d-flex align-items-center",
                                  key: phoneIndex
                                }, [
                                  _hoisted_26,
                                  _createElementVNode("span", _hoisted_27, _toDisplayString(phone), 1)
                                ]))
                              }), 128))
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (scope.row.sites.length > 0)
                        ? (_openBlock(), _createElementBlock("tr", _hoisted_28, [
                            _createElementVNode("td", _hoisted_29, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(scope.row.sites, (site, siteIndex) => {
                                return (_openBlock(), _createElementBlock("p", {
                                  class: "paragraph my-1 mx-3 d-flex align-items-center",
                                  key: siteIndex
                                }, [
                                  _hoisted_30,
                                  _createElementVNode("span", _hoisted_31, _toDisplayString(site), 1)
                                ]))
                              }), 128))
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("tr", null, [
                        _hoisted_32,
                        _createElementVNode("td", _hoisted_33, [
                          _createElementVNode("p", _hoisted_34, _toDisplayString(scope.row.created_at), 1)
                        ])
                      ]),
                      _createElementVNode("tr", null, [
                        _hoisted_35,
                        _createElementVNode("td", null, [
                          _createElementVNode("p", _hoisted_36, _toDisplayString(scope.row.updated_at), 1)
                        ])
                      ])
                    ])
                  ], 2)
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, { class: "py-5 px-0 align-top" }, {
                header: _withCtx(() => [
                  _hoisted_37
                ]),
                default: _withCtx((scope) => [
                  _createElementVNode("div", {
                    class: _normalizeClass(_ctx.rowClasses)
                  }, [
                    _createElementVNode("div", _hoisted_38, [
                      _createVNode(_component_el_checkbox_group, {
                        class: "my-2",
                        size: "small",
                        modelValue: scope.row.reasons,
                        "onUpdate:modelValue": ($event: any) => ((scope.row.reasons) = $event)
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.reasons, (reasonItem, reasonIndex) => {
                            return (_openBlock(), _createBlock(_component_el_checkbox, {
                              key: reasonIndex,
                              label: reasonItem,
                              class: "mb-2",
                              onChange: ($event: any) => (_ctx.checkItemOnReasonSelect(scope.$index))
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(reasonItem.value.name), 1)
                              ]),
                              _: 2
                            }, 1032, ["label", "onChange"]))
                          }), 128))
                        ]),
                        _: 2
                      }, 1032, ["modelValue", "onUpdate:modelValue"])
                    ]),
                    (_openBlock(), _createBlock(_component_el_collapse, {
                      class: "px-2",
                      key: scope.$index
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_collapse_item, {
                          title: 
                      `Лог одобрений ${
                        scope.row.approved_log
                          ? scope.row.approved_log.count
                          : '0'
                      }`
                    ,
                          name: "1"
                        }, {
                          default: _withCtx(() => [
                            (
                        scope.row.approved_log && scope.row.approved_log.count
                      )
                              ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                                  (
                          scope.row.approved_log.log &&
                            scope.row.approved_log.log.length
                        )
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                                        _hoisted_41,
                                        _createVNode(_component_el_timeline, null, {
                                          default: _withCtx(() => [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(scope.row.approved_log
                              .log, (reason, index) => {
                                              return (_openBlock(), _createBlock(_component_el_timeline_item, {
                                                key: index,
                                                timestamp: reason.date
                                              }, {
                                                default: _withCtx(() => [
                                                  _createElementVNode("a", _hoisted_42, [
                                                    _createElementVNode("strong", null, _toDisplayString(reason.moderator.name), 1)
                                                  ])
                                                ]),
                                                _: 2
                                              }, 1032, ["timestamp"]))
                                            }), 128))
                                          ]),
                                          _: 2
                                        }, 1024)
                                      ]))
                                    : _createCommentVNode("", true)
                                ]))
                              : (_openBlock(), _createElementBlock("div", _hoisted_43, _hoisted_45))
                          ]),
                          _: 2
                        }, 1032, ["title"])
                      ]),
                      _: 2
                    }, 1024)),
                    (_openBlock(), _createBlock(_component_el_collapse, {
                      class: "px-2",
                      key: scope.$index
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_collapse_item, {
                          title: 
                      `Лог отклонений ${
                        scope.row.rejected_log
                          ? scope.row.rejected_log.count
                          : '0'
                      }`
                    ,
                          name: "2"
                        }, {
                          default: _withCtx(() => [
                            (
                        scope.row.rejected_log && scope.row.rejected_log.count
                      )
                              ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
                                  _createElementVNode("p", null, " отменено раз: " + _toDisplayString(scope.row.rejected_log.count), 1),
                                  (
                          scope.row.rejected_log.log &&
                            scope.row.rejected_log.log.length
                        )
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
                                        _hoisted_48,
                                        _createVNode(_component_el_timeline, null, {
                                          default: _withCtx(() => [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(scope.row.rejected_log
                              .log, (reason, index) => {
                                              return (_openBlock(), _createBlock(_component_el_timeline_item, {
                                                key: index,
                                                timestamp: reason.date
                                              }, {
                                                default: _withCtx(() => [
                                                  _createElementVNode("p", _hoisted_49, _toDisplayString(reason.text), 1),
                                                  _createElementVNode("a", _hoisted_50, [
                                                    _createElementVNode("strong", null, _toDisplayString(reason.moderator.name), 1)
                                                  ])
                                                ]),
                                                _: 2
                                              }, 1032, ["timestamp"]))
                                            }), 128))
                                          ]),
                                          _: 2
                                        }, 1024)
                                      ]))
                                    : _createCommentVNode("", true)
                                ]))
                              : (_openBlock(), _createElementBlock("div", _hoisted_51, _hoisted_53))
                          ]),
                          _: 2
                        }, 1032, ["title"])
                      ]),
                      _: 2
                    }, 1024))
                  ], 2)
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                fixed: "right",
                width: "60"
              }, {
                default: _withCtx((scope) => [
                  _createElementVNode("div", {
                    class: _normalizeClass(_ctx.rowClasses)
                  }, [
                    _createVNode(_component_el_button_group, { class: "d-flex flex-column" }, {
                      default: _withCtx(() => [
                        _createElementVNode("button", {
                          class: "btn btn-sm btn-icon btn-active-icon-primary overflow-hidden",
                          title: "Одобрить компанию",
                          onClick: ($event: any) => (_ctx.allowEntry(scope.row))
                        }, _hoisted_56, 8, _hoisted_54),
                        _createElementVNode("button", _hoisted_57, [
                          _createVNode(_component_router_link, {
                            class: "btn-sm",
                            to: {
                        name: 'companies-edit',
                        params: {
                          id: scope.row.id,
                          entry: JSON.stringify(scope.row),
                        },
                      }
                          }, {
                            default: _withCtx(() => [
                              _hoisted_58
                            ]),
                            _: 2
                          }, 1032, ["to"])
                        ]),
                        _createElementVNode("button", {
                          class: "btn btn-sm btn-icon btn-active-icon-primary overflow-hidden",
                          title: "Отклонить компанию",
                          disabled: !scope.row.reasons.length,
                          onClick: ($event: any) => (_ctx.rejectEntry(scope.row))
                        }, [
                          _createElementVNode("i", {
                            class: _normalizeClass(["bi bi-x-circle-fill fs-3", {
                        'text-warning': scope.row.reasons.length,
                      }])
                          }, null, 2)
                        ], 8, _hoisted_59)
                      ]),
                      _: 2
                    }, 1024)
                  ], 2)
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["data"])), [
            [_directive_loading, _ctx.isLoading]
          ]),
          (_ctx.tableHasContent)
            ? (_openBlock(), _createElementBlock("div", _hoisted_60, [
                _createVNode(_component_el_button, {
                  size: "small",
                  type: "success",
                  title: 
              !_ctx.someCheckboxesAreChecked
                ? 'Выберите хотя бы один элемент из списка'
                : 'Одобрить компании'
            ,
                  disabled: !_ctx.someCheckboxesAreChecked,
                  onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.allowEntriesBulk()))
                }, {
                  default: _withCtx(() => [
                    _hoisted_61
                  ]),
                  _: 1
                }, 8, ["title", "disabled"]),
                _createVNode(_component_el_button, {
                  size: "small",
                  type: "warning",
                  title: _ctx.rejectButtonTitle,
                  disabled: _ctx.bulkRejectStatus,
                  onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.rejectEntriesBulk()))
                }, {
                  default: _withCtx(() => [
                    _hoisted_62
                  ]),
                  _: 1
                }, 8, ["title", "disabled"]),
                _createVNode(_component_el_button, {
                  size: "small",
                  type: "danger",
                  title: 
              !_ctx.someCheckboxesAreChecked
                ? 'Выберите хотя бы один элемент из списка'
                : 'Удалить компании'
            ,
                  disabled: !_ctx.someCheckboxesAreChecked,
                  onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.deleteEntriesBulk()))
                }, {
                  default: _withCtx(() => [
                    _hoisted_63
                  ]),
                  _: 1
                }, 8, ["title", "disabled"])
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["onFilterCompaniesButtonClick", "items-total", "pages-total", "current-page"])
    ])
  ]))
}